import { LeafIcon, MapPin } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { ConservationBadge } from '@/components/conservation'
import { Skeleton } from '@/components/skeleton'
import { Property } from '@/models/property'

interface FeaturedPropertiesProps {
  property: Property
}

export function FeaturedProperties({ property }: FeaturedPropertiesProps) {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => navigate(`/property/${property.id_propriedade}`)}
      key={property.id_propriedade}
      className="grid h-full min-h-[500px] cursor-pointer rounded-2xl lg:grid-cols-2 2xl:min-h-[600px]"
    >
      <div className="relative h-full min-h-40 w-full select-none overflow-hidden lg:h-full">
        {property.imagens &&
        (
          property.imagens.find((image) => image.destaque) ||
          property.imagens[0]
        ).url_obj ? (
          <img
            src={
              (
                property.imagens.find((image) => image.destaque) ||
                property.imagens[0]
              ).url_obj
            }
            alt="Imagem da propriedade"
            className="pointer-events-none absolute h-full w-full select-none rounded-t-2xl object-cover lg:rounded-r-none lg:rounded-bl-2xl"
          />
        ) : (
          <Skeleton className="absolute h-full w-full rounded-b-none rounded-t-2xl object-cover lg:rounded-b-2xl lg:rounded-r-none" />
        )}
      </div>
      <div className="flex flex-col gap-5 rounded-b-2xl bg-bios-green-3000 px-8 py-10 lg:rounded-bl-none lg:rounded-tr-2xl xl:px-12 2xl:px-24 2xl:py-20">
        <div className="flex flex-row items-center justify-center xl:justify-start">
          <h1
            className="card-title text-shadow-title text-center text-2xl text-white md:text-4xl"
            data-wg-notranslate
          >
            {property.dadosbasicos.nome_propriedade}
          </h1>
        </div>

        <div className="flex h-16 items-center justify-center md:h-full xl:justify-start">
          <p className="line-clamp-2 text-center text-white md:line-clamp-4 xl:line-clamp-6 xl:text-start">
            {property.dadosbasicos.sobre_propriedade}
          </p>
        </div>

        <div className="flex flex-col items-center gap-5 2xl:flex-row 2xl:gap-14">
          <ConservationBadge type={property.tipo_conservacao} />

          <div className="flex flex-col gap-5 sm:flex-row xl:gap-14">
            <div className="flex items-center gap-2">
              <LeafIcon className="text-bios-primary" />
              <span className="text-sm text-bios-primary 2xl:text-lg">
                Bioma {property.endereco.bioma}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <MapPin className="text-bios-primary" size={20} />
              <span className="text-sm text-bios-primary 2xl:text-lg">
                {property.endereco.cidade} - {property.endereco.estado}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
